var map = {
	"./gcse-biology.json": 6575,
	"./gcse-business.json": 4364,
	"./gcse-chemistry.json": 9247,
	"./gcse-englang.json": 3955,
	"./gcse-englit.json": 5833,
	"./gcse-maths.json": 7619,
	"./gcse-physics.json": 4547,
	"./gcse-religious-studies.json": 5037,
	"./gcse-welsh-language.json": 4148,
	"./gcse-welsh-literature.json": 8740,
	"./gcse-welsh-second.json": 1101,
	"./mfw-gcse-business.json": 4359,
	"./mfw-gcse-computer-sci.json": 9882,
	"./mfw-gcse-core-cymraeg.json": 9601,
	"./mfw-gcse-drama.json": 113,
	"./mfw-gcse-englitlang.json": 1201,
	"./mfw-gcse-food.json": 5753,
	"./mfw-gcse-geography.json": 9488,
	"./mfw-gcse-history.json": 6644,
	"./mfw-gcse-level-2-additional-core-cymraeg.json": 9170,
	"./mfw-gcse-mathematics-and-numeracy.json": 2692,
	"./mfw-gcse-music.json": 2768,
	"./mfw-gcse-religious-studies.json": 4440,
	"./mfw-gcse-welsh-language-and-literature.json": 6973,
	"./test-test.json": 7791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 752;